import React, { useCallback, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';

import { ROUTE } from '~/app/routes';
import { Loading } from '~/components';
import { BankAccountsTable } from '~/components/BankAccountsTable';
import { useNavigate } from '~/lib/navigation';
import { useSessionStore } from '~/stores/Session';

import { createEntityModeRequestOptions } from './_util/entityApiMode';
import { Mode, RootEntityOutletContext } from './_util/RootEntityContext';

export const PageRootEntityAccounts: React.FC = () => {
  const navigate = useNavigate();
  const setSandbox = useSessionStore((state) => state.setSandbox);
  const platformId = useSessionStore((state) => state.currentPlatform?.id);
  const { mode, sandboxRootEntity, liveRootEntity, isSandboxLoading, isLiveLoading } =
    useOutletContext<RootEntityOutletContext>();
  const rootEntity = mode === Mode.Sandbox ? sandboxRootEntity : liveRootEntity;
  const isLoading = mode === Mode.Sandbox ? isSandboxLoading : isLiveLoading;
  const handleAccountClick = useCallback(
    (accountId: string) => {
      setSandbox(mode === Mode.Sandbox);
      navigate(`${ROUTE.BANK_ACCOUNTS}/edit/${accountId}`);
    },
    [mode, navigate, setSandbox]
  );
  const requestOptions = useMemo(
    () => createEntityModeRequestOptions(platformId ?? '', mode === Mode.Live),
    [platformId, mode]
  );

  return (
    <Loading isLoading={isLoading}>
      <BankAccountsTable
        entityId={rootEntity?.id ?? null}
        onAccountClick={handleAccountClick}
        requestOptions={requestOptions}
      />
    </Loading>
  );
};
